import { PaymentProductItem } from './PaymentProductItem';
export const PaymentProduct = {
    items: PaymentProductItem,
    min: 0,
    max: 100,
};
